import React, { useMemo } from 'react'

import { PayPalScriptProvider } from '@paypal/react-paypal-js'

const withPayPal = (Component) => {
  const PreppedComponent = (props) => {
    const { payPalClientId, payPalToggle, braintreeClientToken, currency, disablePayLater = false } = props

    if (typeof window === 'undefined') {
      return <Component {...props} />
    }

    const options = useMemo(() => {
      if (!payPalToggle) {
        return {
          'client-id': 'test',
          components: '',
        }
      }

      return {
        intent: 'capture',
        components: 'messages,buttons',
        currency,
        'client-id': payPalClientId,
        dataClientToken: braintreeClientToken,
        disableFunding: [...(disablePayLater ? ['paylater'] : []), 'card'],
      }
    }, [payPalClientId, payPalToggle, braintreeClientToken, currency, disablePayLater])

    return (
      <PayPalScriptProvider options={options}>
        <Component {...props} />
      </PayPalScriptProvider>
    )
  }

  PreppedComponent.displayName = 'withPayPal'

  return PreppedComponent
}

export default withPayPal
